import React from 'react';
import {Header, Icon,Container, Loader, Dropdown, Divider, Form, Dimmer, TextArea, Segment, Button, Grid,Input, Radio, Image} from 'semantic-ui-react';
import { Link } from "react-router-dom";


import moment from 'moment';
import dayjs from 'dayjs';
import 'moment/locale/es';
import { DatePicker, Space } from 'antd';
import locale from 'antd/es/date-picker/locale/es_ES';
import "antd/dist/reset.css";
const dateFormat = 'DD/MM/YYYY';


const ContenidoForm=({ id, color, form, onSave,onChange, archivos, tipoContenidoCombo, ajaxCallInProgress, datos, errors={}, strings, permisos, formularioCombo, crucigramaCombo, onBuscar, goBack, close,fecha, fechaStr, onHandleFileImagen, archivo, comboInstructor})=>{



	return (
        <Container >

          <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big' inline content={strings?strings["Procesando"]:""}/>
          </Dimmer>

			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
                            <Segment>    
        
                            <Form.Field  required  error={errors.titulo}>            
                                  <label  >{strings?strings["agrupador"]:""}</label>
                                  <Input 
                                        placeholder={strings?strings["agrupador"]:""} 
                                        name="agrupador"
                                        onChange={onChange}
                                        value={datos.agrupador}
                                        icon='edit'/>
                        
                            
                            
        
                                </Form.Field>
        
                                <DatePicker bordered={false}
                                    value={datos.fecha2==null?"":dayjs(datos.fecha2, dateFormat)}

                                    onChange={(dates, dateStrings)=>fecha(dates, dateStrings, "agrupador")} 
                                    locale={locale} 
                                    size="large" 
                                    format={dateFormat} />
                                    
                                <Form.Field >
                                  <label  >{strings?strings["instructor"]:""}</label>
                                  <Dropdown 
                                        placeholder={strings?strings["instructor"]:""} 
                                        name="idUsuario"
                                         fluid 
                                        search 
                                        selection

                                        onChange={onChange}
                                        value={datos.idUsuario}
                                        options={comboInstructor}/>
                                </Form.Field>


                            </Segment>    
                            
                            <Form.Field  required  error={errors.titulo}>            
                              <label  >{strings?strings["titulo"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["titulo"]:""} 
                                    name="titulo"
                                    onChange={onChange}
                                    value={datos.titulo}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.descripcion}>            
                              <label  >{strings?strings["descripcion"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["descripcion"]:""} 
                                    name="descripcion"
                                    onChange={onChange}
                                    value={datos.descripcion}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.tiempo}>            
                              <label  >{strings?strings["tiempo"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["tiempo"]:""} 
                                    name="tiempo"
                                    onChange={onChange}
                                    value={datos.tiempo}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.idTipo}>
                              <label  >{strings?strings["tipo"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["tipo"]:""} 
                                    name="idTipo"
									 fluid 
                                    search 
                                    selection
                                    
                                    onChange={onChange}
                                    value={datos.idTipo}
                                    options={tipoContenidoCombo}/>
                            </Form.Field>
        
                            {datos.idTipo==27?        
        
        
                                <>

                                    <Form.Field  required  error={errors.prefijo}>            
                                      <label  >{strings?strings["prefijo"]:""}</label>
                                      <Input 
                                            placeholder={strings?strings["prefijo"]:""} 
                                            name="prefijo"
                                            onChange={onChange}
                                            value={datos.prefijo}
                                            icon='edit'/>
                                    </Form.Field>

                                    <Button  color="black"
                                        onClick={onBuscar}>{strings?strings["buscar"]:""}
                                     </Button>


                                    <Form.Field  required  error={errors.archivo}>
                                      <label  >{strings?strings["archivo"]:""}</label>
                                      <Dropdown 
                                            placeholder={strings?strings["archivo"]:""} 
                                            name="archivo"
                                             fluid 
                                            search 
                                            selection

                                            onChange={onChange}
                                            value={datos.archivo}
                                            options={archivos}/>
                                    </Form.Field>

                                </>
        
                             :
                                ""
                            }
                            
                            {datos.idTipo==26 || datos.idTipo==29?        
        
        
                                <>
                                
                                    <Form.Field error={errors.archivoF} >
                                        <label>{strings?strings[""]:""} </label>
                                        <Input placeholder='archivoImagenPdf'
                                        onChange={(a, b)=>onHandleFileImagen(a,b,1)}
                                        name="archivo"
                                        type='file'

                                    />
                                    <br/>  <br/>      

                                    {archivo.imagePreviewUrl?
                                            <Segment basic>
                                                <Image src={"/info/resource/?nombre="+archivo.imagePreviewUrl} size="big" fluid />
                                            </Segment>

                                        :
                                            ""

                                    }

                                    {archivo.pdf==1?
        
        
                                    <>
                                            <Icon name="file pdf outline" size="big"
                                                color="teal"/> Archivo en formato PDF
                                        </>
                                        :
                                        
                                            ""
                                    }
                                    
                                    </Form.Field>
                                    
                                
                                    <Segment>

                                        <Form.Field  required  error={errors.prefijo}>            
                                          <label  >{strings?strings["prefijo"]:""}</label>
                                          <Input 
                                                placeholder={strings?strings["prefijo"]:""} 
                                                name="prefijo"
                                                onChange={onChange}
                                                value={datos.prefijo}
                                                icon='edit'/>
                                        </Form.Field>

                                        <Button  color="black"
                                            onClick={onBuscar}>{strings?strings["buscar"]:""}
                                         </Button>
        

                                        <Form.Field  required  error={errors.archivo}>
                                          <label  >{strings?strings["archivo"]:""}</label>
                                          <Dropdown 
                                                placeholder={strings?strings["archivo"]:""} 
                                                name="archivo"
                                                 fluid 
                                                search 
                                                selection

                                                onChange={onChange}
                                                value={datos.archivo}
                                                options={archivos}/>
                                        </Form.Field>
                                    </Segment>                

                                    </>
        
                             :
                                ""
                            }
                            {datos.idTipo==28?
        
                            
                            ////// FECHAS DE EXAMEN
                            <div>    
                                
                            <DatePicker 
                                    bordered={false}
                                    value={dayjs(datos.fechaInicioExamen, dateFormat)}
                                    onChange={(dates, dateStrings)=>fecha(dates, dateStrings, "fechaInicioExamen")} 
                                    locale={locale} 
                                    size="large" 
                                    allowClear={false}
                                    format={dateFormat} />
                            
                            
                            <DatePicker 
                                    bordered={false}
                                    value={dayjs(datos.fechaTerminoExamen, dateFormat)}
                                    onChange={(dates, dateStrings)=>fecha(dates, dateStrings, "fechaTerminoExamen")} 
                                    locale={locale} 
                                    allowClear={false}
                                    size="large" 
                                    format={dateFormat} />
        
                            <Form.Field  required  error={errors.idFormulario}>
                              <label  >{strings?strings["Examen"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["Examen"]:""} 
                                    name="idFormulario"
									 fluid 
                                    search 
                                    selection
                                    
                                    onChange={onChange}
                                    value={datos.idFormulario}
                                    options={formularioCombo}/>
                            </Form.Field>
        
                            </div>        
                                    
                                    
                            :
                                ""
                            }
        
        
                             {datos.idTipo==30||datos.idTipo==31?
        
                            <Form.Field  required  error={errors.url}>            
                              <label  >{strings?strings["URL"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["URL"]:""} 
                                    name="url"
                                    onChange={onChange}
                                    value={datos.url}
                                    icon='edit'/>
                            </Form.Field>
        
                            :
                                ""
                            }

                            {datos.idTipo==32?
        
                            <Form.Field  required  error={errors.idFormulario}>
                              <label  >{strings?strings["crucigrama"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["crucigrama"]:""} 
                                    name="juego"
									fluid 
                                    search 
                                    selection
                                    
                                    onChange={onChange}
                                    value={datos.juego}
                                    options={crucigramaCombo}/>
                            </Form.Field>
        
                            :
                                ""
                            }
                                          
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                               
                                <Button  onClick={close}
										>{strings?strings["cerrar"]:""}</Button>
        
                                <Button.Or text=" "></Button.Or>
								  
								 
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
								 
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        </Container>
	);
};



export default ContenidoForm;